import { Injectable } from '@angular/core';
import { HttpService } from '../../../shared/services/http/http-client.service';
import { environment } from '../../../../environments/environment';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class ListarReusoVinculadoService {

  constructor(
    private http: HttpService
  ) { }

  listReusoDestinados(data: any, successHandle: Function, errorHandle: Function) {

    return this.http.doGet('/automaticReuse/cadastradosDestinados', data, successHandle, errorHandle);

  }
}
